import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=e48e178e&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports